import { render } from "./DangerIcon.vue?vue&type=template&id=7b33ca28"
import script from "./DangerIcon.vue?vue&type=script&lang=js"
export * from "./DangerIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__